import React from "react";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

function HolidayDropdown(props) {
  return (
    <>
        <FormControl style={{ width: "100%" }} variant="filled">
          <InputLabel id="holiday-single-select-label">Holiday:</InputLabel>
          <Select
            labelId="holiday-single-select-label"
            id="holiday-single-select"
            label="Holiday"
            onChange={(e) => {props.handleHolidaySelect(e.target.value)}}
          >
              <MenuItem key={"1"} value={"1"}>
                New Years Day
              </MenuItem>
              <MenuItem key={"2"} value={"2"}>
                January 2nd
              </MenuItem>
              <MenuItem key={"3"} value={"3"}>
                St Patricks Day
              </MenuItem>
              <MenuItem key={"4"} value={"4"}>
                Good Friday
              </MenuItem>
              <MenuItem key={"5"} value={"5"}>
                Easter Monday
              </MenuItem>
              <MenuItem key={"6"} value={"6"}>
                Early May Bank Holiday
              </MenuItem>
              <MenuItem key={"7"} value={"7"}>
                Spring Bank Holiday
              </MenuItem>
              <MenuItem key={"8"} value={"8"}>
                Battle of the Boyne
              </MenuItem>
              <MenuItem key={"9"} value={"9"}>
                Summer Bank Holiday
              </MenuItem>
              <MenuItem key={"10"} value={"10"}>
                Christmas Eve
              </MenuItem>
              <MenuItem key={"11"} value={"11"}>
                Christmas Day
              </MenuItem>
              <MenuItem key={"12"} value={"12"}>
                Boxing Day
              </MenuItem>
              <MenuItem key={"13"} value={"13"}>
                Extra Day
              </MenuItem>
              <MenuItem key={"14"} value={"14"}>
                New years Eve
              </MenuItem>
              <MenuItem key={"15"} value={"15"}>
                Extra Holiday 15
              </MenuItem>
          </Select>
        </FormControl>
    </>
  );
}

export default HolidayDropdown;
